( function () {
	'use strict';
	/* globals angular */
	function warehouseExportFactory ( apiService, logger ) {
		var tempalteErr    = 'Unable to fetch Template list. Please try again later';
		var observationErr = 'Unable to fetch Observation list. Please try again later';

		function handleFetchErrors ( message ) {
			function displayErrorMessage () {
				logger.notifyError( message );
			}

			return displayErrorMessage;
		}

		function passThrough ( data ) {
			return data;
		}

		function buildTemplateFilter ( template ) {
			return {
				'id'        : template.id,
				'name'      : template.name,
				'createdAt' : template.createdAt
			};
		}

		function processFetchedTemplates ( data ) {
			return ( data || [] ).map( buildTemplateFilter );
		}

		function fetchTemplates () {
			return apiService.getTemplatesForReports.query().$promise.then( processFetchedTemplates, handleFetchErrors( tempalteErr ) );
		}

		function fetchObservationCSVExport ( templateId ) {
			return apiService.getObservationExport( templateId ).then( passThrough, handleFetchErrors( observationErr ) );
		}

		return {
			'fetchTemplates'            : fetchTemplates,
			'fetchObservationCSVExport' : fetchObservationCSVExport
		};
	}

	warehouseExportFactory.$inject = [ 'apiService', 'logger' ];

	angular
		.module( 'app.report' )
		.factory( 'warehouseExportFactory', warehouseExportFactory );
} )( );
